/* Creator Reels for Shopify - ported from the WordPress plugin v3.2.0 */
(function(){
'use strict';
var INST={};

/* ---------- data helpers (Liquid gives raw product data, we shape it here) ---------- */
function dec(s){
  if(!s)return '';
  s=String(s);
  if(s.indexOf('&')<0)return s;
  var t=document.createElement('textarea');t.innerHTML=s;return t.value;
}
function pct(price,compare){
  return(compare>price&&price>0)?Math.round((compare-price)/compare*100):0;
}
/* raw reel (from Liquid) -> the shape the UI code below expects */
function prep(r,badge){
  var imgs=(r.images||[]).slice();
  var d={
    video:r.video,
    poster:r.poster||imgs[0]||'',
    images:imgs,
    thumb:r.thumb||imgs[0]||'',
    name:r.name||'',
    desc:r.desc||'',
    url:r.url||'',
    pid:'',vid:0,oos:false,
    sell:'',mrp:'',off:0,vr:null
  };
  var p=r.p;
  if(p&&p.variants&&p.variants.length){
    var vs=p.variants,dv=null,i,j;
    for(i=0;i<vs.length;i++){if(vs[i].available){dv=vs[i];break;}}
    if(!dv)dv=vs[0];
    d.pid=String(p.id);d.vid=dv.id;d.oos=!p.available;
    d.sell=dec(dv.sell);
    d.mrp=dv.compare>dv.price?dec(dv.mrp):'';
    d.off=pct(dv.price,dv.compare);
    if(vs.length>1&&p.options&&p.options.length){
      var attrs=[];
      p.options.forEach(function(on,k){
        var seen={},o=[];
        vs.forEach(function(v){var val=v.o[k];if(val!==undefined&&!seen[val]){seen[val]=1;o.push({v:val,l:val});}});
        attrs.push({k:'o'+k,l:(on&&on.name)?on.name:String(on),o:o});
      });
      var vars=vs.map(function(v){
        var at={};v.o.forEach(function(val,k){at['o'+k]=val;});
        return{id:v.id,at:at,sell:dec(v.sell),mrp:v.compare>v.price?dec(v.mrp):'',img:v.img||'',ok:!!v.available};
      });
      var def={};
      if(dv.available){dv.o.forEach(function(val,k){def['o'+k]=val;});}
      d.vr={attrs:attrs,vars:vars,def:def};
    }
  }else{
    d.sell=dec(r.sell);d.mrp=dec(r.mrp);d.off=r.off||0;
  }
  if(!badge)d.off=0;
  return d;
}

function mount(sec){
var modal=document.getElementById(sec.getAttribute('data-modal'));
if(!modal)return null;
var offs=[];
document.body.appendChild(modal);
function q(s){return modal.querySelector(s);}
var vs=q('.ccr-vs'),prog=q('.ccr-prog i'),
    btnMute=q('[data-mute]'),btnClose=q('[data-close]'),btnPrev=q('[data-mprev]'),btnNext=q('[data-mnext]'),
    bar=q('[data-bar]'),bOff=q('.ccr-bo'),bTh=q('.ccr-bth'),bN=q('.ccr-bn'),bS=q('.ccr-bp b'),bM=q('.ccr-bp s'),
    gw=q('.ccr-gw'),gal=q('[data-gal]'),dash=q('[data-dash]'),gPrev=q('[data-gprev]'),gNext=q('[data-gnext]'),
    vr=q('[data-vr]'),ds=q('.ccr-ds'),dc=q('.ccr-dc'),pt=q('.ccr-pt'),pS=q('.ccr-pr b'),pM=q('.ccr-pr s'),
    acb=q('.ccr-acb'),acl=acb.querySelector('span'),toast=q('.ccr-toast'),
    sclose=[].slice.call(modal.querySelectorAll('[data-sclose]'));
var cartUrl=modal.getAttribute('data-cart')||'/cart',root=modal.getAttribute('data-root')||'/',afterAdd=modal.getAttribute('data-after')||'toast',
    btnLabel=acl.textContent,T={select:'Please select {option}',combo:'This combination is unavailable',oos:'Out of stock',adding:'Adding\u2026',added:'Added to cart',cart:'View cart',retry:'Try again'};
try{var tt=JSON.parse(modal.getAttribute('data-t')||'{}');for(var tk in tt){if(tt[tk])T[tk]=tt[tk];}}catch(e){}
var pool=[],mv=null,swapTok=0,fresh=true,list=[],cur=0,muted=false,isOpen=false,closeTimer=null,toastTimer=null,prevOverflow='',busy=false,sel={},gExtra='',curV=null;

var SVG_ON='<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
var SVG_OFF='<svg viewBox="0 0 24 24"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.8 8.8 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
function icon(){btnMute.innerHTML=muted?SVG_OFF:SVG_ON;}

function play(){
  if(!mv)return;
  mv.muted=muted;
  var p=mv.play();
  if(p&&p.catch)p.catch(function(err){
    if(err&&err.name==='AbortError')return;
    if(!mv.muted){mv.muted=true;muted=true;icon();var r=mv.play();if(r&&r.catch)r.catch(function(){});}
  });
}

/* ---- popup video pool: current + next + prev preloaded so switching is instant ---- */
(function(){
  var a=q('.ccr-mv');
  var b=a.cloneNode(false),c=a.cloneNode(false);
  b.classList.remove('front');c.classList.remove('front');
  vs.insertBefore(b,a.nextSibling);vs.insertBefore(c,b.nextSibling);
  pool=[a,b,c];mv=a;
  pool.forEach(function(el){
    el.__i=-1;el.muted=true;
    el.addEventListener('timeupdate',function(){if(el===mv&&el.duration)prog.style.width=(el.currentTime/el.duration*100)+'%';});
  });
})();
function loadInto(el,idx,pre){
  var u=list[idx].video;
  el.pause();el.__i=idx;el.preload=pre||'auto';el.muted=true;el.removeAttribute('poster');
  if(el.getAttribute('src')!==u){el.src=u;el.load();}
}
function playEl(el){
  var pr=el.play();
  if(pr&&pr.catch)pr.catch(function(err){
    if(err&&err.name==='AbortError')return;
    if(!el.muted){el.muted=true;muted=true;icon();var r=el.play();if(r&&r.catch)r.catch(function(){});}
  });
}
function setFront(el){pool.forEach(function(x){x.classList.toggle('front',x===el);});}
function preloadNeighbors(){
  var n=list.length;if(n<2)return;
  var want=[(cur+1)%n];if(n>2)want.push((cur-1+n)%n);
  want.forEach(function(idx,k){
    if(pool.some(function(x){return x.__i===idx;}))return;
    var el=null;
    for(var j=0;j<pool.length;j++){var x=pool[j];if(x!==mv&&want.indexOf(x.__i)<0){el=x;break;}}
    if(el)loadInto(el,idx,k===0?'auto':'metadata');
  });
}
function snap(v){
  try{
    if(!v||v.readyState<2||!v.videoWidth)return '';
    var w=Math.min(540,v.videoWidth),h=Math.round(v.videoHeight*w/v.videoWidth);
    var cv=document.createElement('canvas');cv.width=w;cv.height=h;
    cv.getContext('2d').drawImage(v,0,0,w,h);
    return cv.toDataURL('image/jpeg',0.82);
  }catch(e){return '';}
}
/* show video idx. The old frame stays visible until the new one is ready (no cover flash in between). */
function showVideo(idx,srcVid){
  var d=list[idx],tok=++swapTok,n=list.length,tgt=null,i;
  pool.forEach(function(x){if(x!==mv)x.pause();});
  prog.style.width='0';
  if(fresh){
    fresh=false;
    tgt=mv;loadInto(tgt,idx,'auto');
    var t=srcVid?srcVid.currentTime:0,po=srcVid?snap(srcVid):'';
    tgt.poster=po||d.poster||'';
    if(t>0.2){
      var seek=function(){tgt.removeEventListener('loadedmetadata',seek);try{if(tgt.duration&&t<tgt.duration-1)tgt.currentTime=t;}catch(e){}};
      tgt.addEventListener('loadedmetadata',seek);
    }
    setFront(tgt);tgt.muted=muted;playEl(tgt);
    preloadNeighbors();
    return;
  }
  for(i=0;i<pool.length;i++){if(pool[i].__i===idx){tgt=pool[i];break;}}
  if(tgt===mv){ /* same video again */
    try{mv.currentTime=0;}catch(e){}
    mv.muted=muted;playEl(mv);preloadNeighbors();return;
  }
  if(!tgt){
    var nx=(idx+1)%n,pv=(idx-1+n)%n;
    for(i=0;i<pool.length;i++){var x=pool[i];if(x!==mv&&x.__i!==nx&&x.__i!==pv){tgt=x;break;}}
    if(!tgt){for(i=0;i<pool.length;i++){if(pool[i]!==mv){tgt=pool[i];break;}}}
    loadInto(tgt,idx,'auto');
  }
  var old=mv,done=false,onP=null;
  function go(){
    if(done||tok!==swapTok)return;
    done=true;
    if(onP)tgt.removeEventListener('playing',onP);
    tgt.muted=muted;
    setFront(tgt);
    pool.forEach(function(x){if(x!==tgt)x.pause();});
    if(old&&old!==tgt){try{old.currentTime=0;}catch(e){}}
    mv=tgt;
    prog.style.width='0';
    preloadNeighbors();
  }
  try{if(tgt.currentTime>0.1)tgt.currentTime=0;}catch(e){}
  tgt.muted=muted;
  playEl(tgt);
  if(tgt.readyState>=3){go();}
  else{
    onP=function(){go();};
    tgt.addEventListener('playing',onP);
    setTimeout(function(){
      if(!done&&tok===swapTok){tgt.poster=d.poster||'';go();}
    },1500);
  }
}

function setPrice(s,m,d){
  s.textContent=d.sell||'';
  m.textContent=d.mrp||'';
  m.style.display=d.mrp?'':'none';
}

/* gallery */
function slideStep(){var s=gal.children[1]||gal.children[0];return s?s.offsetWidth+6:0;}
function markDash(){
  var n=gal.children.length;if(!n)return;
  var idx=0,max=gal.scrollWidth-gal.clientWidth;
  if(max>2&&gal.scrollLeft>=max-2){idx=n-1;}
  else{var best=1e9;for(var k=0;k<n;k++){var dd=Math.abs(gal.children[k].offsetLeft-gal.scrollLeft);if(dd<best){best=dd;idx=k;}}}
  for(var j=0;j<dash.children.length;j++){dash.children[j].classList.toggle('on',j===idx);}
}
function goTo(k){var s=gal.children[k];if(s)gal.scrollTo({left:s.offsetLeft,behavior:'smooth'});}
gal.addEventListener('scroll',markDash,{passive:true});
gPrev.addEventListener('click',function(e){e.stopPropagation();gal.scrollBy({left:-slideStep(),behavior:'smooth'});});
gNext.addEventListener('click',function(e){e.stopPropagation();gal.scrollBy({left:slideStep(),behavior:'smooth'});});

function buildGallery(d,extra){
  gal.innerHTML='';dash.innerHTML='';
  var imgs=(extra?[extra]:[]).concat(d.images||[]);
  imgs.forEach(function(u,k){
    var s=document.createElement('div');s.className='ccr-gs';
    var im=document.createElement('img');im.src=u;im.alt=d.name||'';im.draggable=false;
    s.appendChild(im);gal.appendChild(s);
    var b=document.createElement('div');b.className='ccr-dd';b.setAttribute('role','button');b.setAttribute('aria-label','Image '+(k+1));
    b.addEventListener('click',function(){goTo(k);});
    dash.appendChild(b);
  });
  gw.style.display=imgs.length?'':'none';
  gw.classList.toggle('multi',imgs.length>1);
  dash.style.display=imgs.length>1?'':'none';
  gal.scrollLeft=0;markDash();
}

/* sheet (mobile) */
function openSheet(){if(modal.classList.contains('no-prod'))return;modal.classList.add('sheet');}
function closeSheet(){modal.classList.remove('sheet');}

function show(i,srcVid){
  cur=(i+list.length)%list.length;
  var d=list[cur];
  closeSheet();hideToast();sel={};gExtra='';curV=null;resetBtn();
  showVideo(cur,srcVid);

  var imgs=d.images||[];
  modal.classList.toggle('no-prod',!(d.name||imgs.length||d.sell||d.desc));

  /* mobile bottom bar */
  bOff.textContent=d.off?d.off+'% OFF':'';
  bOff.style.display=d.off?'':'none';
  if(d.thumb){bTh.src=d.thumb;bTh.style.display='';}else{bTh.removeAttribute('src');bTh.style.display='none';}
  bN.textContent=d.name||'';
  setPrice(bS,bM,d);

  /* product panel */
  buildGallery(d);
  pt.textContent=d.name||'';
  pt.style.display=d.name?'':'none';
  setPrice(pS,pM,d);
  pS.parentNode.style.display=d.sell?'':'none';
  dc.innerHTML=d.desc||'';
  ds.classList.toggle('has',!!(d.desc&&d.desc.trim()));
  q('.ccr-pc').scrollTop=0;

  buildVr(d);
  if(d.pid&&!vrData(d)){acb.classList.toggle('dis',!!d.oos);acl.textContent=d.oos?T.oos:btnLabel;}

  var canBuy=!!(d.url||d.pid);
  acb.style.display=canBuy?'flex':'none';
  acb.setAttribute('href',d.url||'#');
}

function openModal(items,idx,srcVid){
  list=items;
  clearTimeout(closeTimer);
  modal.style.display='flex';
  modal.setAttribute('aria-hidden','false');
  prevOverflow=document.documentElement.style.overflow;
  document.documentElement.style.overflow='hidden';
  isOpen=true;
  requestAnimationFrame(function(){requestAnimationFrame(function(){modal.classList.add('op');});});
  muted=false;icon();
  pool.forEach(function(el){el.pause();el.__i=-1;el.classList.remove('front');});
  mv=pool[0];mv.classList.add('front');
  fresh=true;
  show(idx,srcVid);
}

function closeModal(){
  if(!isOpen)return;
  isOpen=false;
  modal.classList.remove('op');
  modal.setAttribute('aria-hidden','true');
  document.documentElement.style.overflow=prevOverflow;
  closeSheet();hideToast();
  closeTimer=setTimeout(function(){
    modal.style.display='none';
    pool.forEach(function(el){el.pause();el.__i=-1;el.removeAttribute('src');el.removeAttribute('poster');el.load();});
    swapTok++;
  },380);
}

/* add to cart */
function resetBtn(){
  busy=false;acb.classList.remove('busy');
  var d=list[cur];
  acl.textContent=((curV&&!curV.ok)||(d&&d.pid&&!vrData(d)&&d.oos))?T.oos:btnLabel;
}

/* ---- variants: size / color etc. ---- */
function vrData(d){return d&&d.vr&&d.vr.attrs&&d.vr.attrs.length?d.vr:null;}
function same(a,b){return String(a).toLowerCase()===String(b).toLowerCase();}
function vMatch(v,part){for(var k in part){if(v.at[k]!==undefined&&v.at[k]!==''&&!same(v.at[k],part[k]))return false;}return true;}
function findVar(d){
  var r=vrData(d);if(!r)return null;
  for(var i=0;i<r.attrs.length;i++){if(!sel[r.attrs[i].k])return null;}
  var first=null;
  for(var j=0;j<r.vars.length;j++){if(vMatch(r.vars[j],sel)){if(r.vars[j].ok)return r.vars[j];if(!first)first=r.vars[j];}}
  return first;
}
function vmsg(t){var m=vr.querySelector('.ccr-vm');if(!m)return;m.textContent=t||'';m.classList.toggle('on',!!t);}
function buildVr(d){
  vr.innerHTML='';
  var r=vrData(d);
  vr.classList.toggle('has',!!r);
  if(!r){acb.classList.remove('dis');return;}
  r.attrs.forEach(function(a){
    var g=document.createElement('div');g.className='ccr-vg';
    var l=document.createElement('p');l.className='ccr-vl';
    l.appendChild(document.createTextNode(a.l));
    l.appendChild(document.createElement('span'));
    g.appendChild(l);
    var o=document.createElement('div');o.className='ccr-vo';
    a.o.forEach(function(op){
      var c=document.createElement('div');c.className='ccr-ch';c.setAttribute('role','button');c.tabIndex=0;c.textContent=op.l;
      function pick(){if(c.classList.contains('dis'))return;sel[a.k]=op.v;onSel(d);}
      c.addEventListener('click',pick);
      c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();pick();}});
      o.appendChild(c);
    });
    g.appendChild(o);vr.appendChild(g);
  });
  var m=document.createElement('p');m.className='ccr-vm';vr.appendChild(m);
  r.attrs.forEach(function(a){
    var df=r.def&&r.def[a.k];
    if(df){for(var i=0;i<a.o.length;i++){if(same(a.o[i].v,df)){sel[a.k]=a.o[i].v;break;}}}
    if(!sel[a.k]&&a.o.length===1)sel[a.k]=a.o[0].v;
  });
  onSel(d);
}
function onSel(d){
  var r=vrData(d);if(!r)return;
  vmsg('');
  r.attrs.forEach(function(a,gi){
    var g=vr.children[gi],chips=g.querySelectorAll('.ccr-ch'),chosen='';
    a.o.forEach(function(op,ci){
      var on=sel[a.k]===op.v;if(on)chosen=op.l;
      var part={};for(var k in sel){if(k!==a.k)part[k]=sel[k];}part[a.k]=op.v;
      var ok=r.vars.some(function(v){return v.ok&&vMatch(v,part);});
      chips[ci].classList.toggle('on',on);
      chips[ci].classList.toggle('dis',!ok&&!on);
    });
    g.querySelector('.ccr-vl span').textContent=chosen?': '+chosen:'';
  });
  var v=findVar(d);curV=v;
  /* price */
  if(v&&v.sell){pS.textContent=v.sell;pM.textContent=v.mrp||'';pM.style.display=v.mrp?'':'none';pS.parentNode.style.display='';}
  else{setPrice(pS,pM,d);pS.parentNode.style.display=d.sell?'':'none';}
  /* image */
  if(v&&v.img){
    var ix=(d.images||[]).indexOf(v.img);
    if(ix>-1){if(gExtra){gExtra='';buildGallery(d,'');}goTo(ix);}
    else if(gExtra!==v.img){gExtra=v.img;buildGallery(d,v.img);}
    else{goTo(0);}
  }else if(gExtra){gExtra='';buildGallery(d,'');}
  /* stock / button */
  var oos=!!(v&&!v.ok);
  acb.classList.toggle('dis',oos);
  if(!busy)acl.textContent=oos?T.oos:btnLabel;
  if(oos)vmsg(T.combo);
}

/* add to cart */
function hideToast(){clearTimeout(toastTimer);toast.classList.remove('on');}
function showToast(msg,link){
  toast.innerHTML='';
  toast.appendChild(document.createTextNode(msg));
  if(link){var a=document.createElement('a');a.href=link;a.textContent=T.cart;toast.appendChild(a);}
  toast.classList.add('on');
  clearTimeout(toastTimer);
  toastTimer=setTimeout(function(){toast.classList.remove('on');},3800);
}
function cartRefresh(cart){
  /* generic events many themes listen to */
  ['cart:refresh','cart:updated','cart:change'].forEach(function(n){
    try{document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{cart:cart,source:'creator-reels'}}));}catch(e){}
  });
  /* Dawn-family header cart bubble, if present */
  var bub=document.getElementById('cart-icon-bubble');
  if(bub){
    fetch(root+'?sections=cart-icon-bubble',{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(j){
        var h=j&&j['cart-icon-bubble'];if(!h)return;
        var t=document.createElement('div');t.innerHTML=h;
        var n=t.querySelector('.shopify-section');
        if(n)bub.innerHTML=n.innerHTML;
      }).catch(function(){});
  }
}
/* ---- open the theme's cart drawer / notification (Dawn-family: Studio, Dawn, Refresh...) ---- */
var CCR_SECTIONS='cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button';
function applyBubble(s){
  if(!s||!s['cart-icon-bubble'])return;
  var bub=document.getElementById('cart-icon-bubble');if(!bub)return;
  var t=document.createElement('div');t.innerHTML=s['cart-icon-bubble'];
  var n=t.querySelector('.shopify-section');
  if(n)bub.innerHTML=n.innerHTML;
}
/* keep the video popup open; just make sure the cart drawer is drawn ABOVE it (popup z-index is 99999) */
function lift(el){try{el.style.setProperty('z-index','100001','important');}catch(e){}}
function openCartUi(j){
  var s=j&&j.sections;if(!s)return false;
  var dr=document.querySelector('cart-drawer'),nt=document.querySelector('cart-notification');
  if(dr&&s['cart-drawer']){
    lift(dr);
    try{
      if(typeof dr.renderContents==='function'){
        dr.renderContents(j);
        dr.classList.remove('is-empty');
        return true;
      }
    }catch(e){}
    try{
      var tmp=document.createElement('div');tmp.innerHTML=s['cart-drawer'];
      var src=tmp.querySelector('#CartDrawer');
      var dst=document.getElementById('CartDrawer');
      if(dst&&src)dst.innerHTML=src.innerHTML;
      dr.classList.remove('is-empty');
      var inner=dr.querySelector('.drawer__inner');if(inner)inner.classList.remove('is-empty');
      applyBubble(s);
      if(typeof dr.open==='function'){setTimeout(function(){dr.open();});}
      else{dr.classList.add('active','animate');document.body.classList.add('overflow-hidden');}
      return true;
    }catch(e){}
    return false;
  }
  if(nt&&typeof nt.renderContents==='function'){
    lift(nt);
    try{nt.renderContents(j);return true;}catch(e){}
  }
  return false;
}
function addCart(d,v){
  if(busy)return;
  var id=v?v.id:d.vid;
  if(!id)return;
  busy=true;acb.classList.add('busy');acl.textContent=T.adding;
  fetch(root+'cart/add.js',{
    method:'POST',
    credentials:'same-origin',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[{id:id,quantity:1}],sections:CCR_SECTIONS,sections_url:window.location.pathname})
  })
    .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j};});})
    .then(function(res){
      if(!res.ok||(res.j&&(res.j.status||res.j.errors))){
        /* e.g. 422 sold out / max quantity in cart */
        var msg=(res.j&&(res.j.description||res.j.message))||'';
        if(msg){resetBtn();showToast(msg,'');return;}
        if(d.url){window.location.href=d.url;return;}
        acl.textContent=T.retry;busy=false;acb.classList.remove('busy');
        setTimeout(function(){if(!busy)acl.textContent=btnLabel;},1800);
        return;
      }
      if(afterAdd==='cart'){window.location.href=cartUrl;return;}
      acb.classList.remove('busy');acl.textContent=T.added+' \u2713';
      if(!openCartUi(res.j)){
        applyBubble(res.j&&res.j.sections);
        showToast(T.added,cartUrl);
        fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(cartRefresh).catch(function(){});
      }
      setTimeout(resetBtn,1800);
    })
    .catch(function(){
      if(d.url){window.location.href=d.url;return;}
      resetBtn();
    });
}
acb.addEventListener('click',function(e){
  var d=list[cur];if(!d)return;
  if(d.pid){
    e.preventDefault();
    var r=vrData(d);
    if(r){
      for(var i=0;i<r.attrs.length;i++){
        if(!sel[r.attrs[i].k]){
          vmsg(T.select.replace('{option}',r.attrs[i].l));
          var g=vr.children[i];g.classList.remove('shake');void g.offsetWidth;g.classList.add('shake');
          if(g.scrollIntoView)g.scrollIntoView({block:'nearest',behavior:'smooth'});
          return;
        }
      }
      if(!curV||!curV.ok){vmsg(T.combo);return;}
      addCart(d,curV);
    }else{addCart(d,null);}
  }else if(!d.url){e.preventDefault();}
});

btnPrev.addEventListener('click',function(){show(cur-1);});
btnNext.addEventListener('click',function(){show(cur+1);});
btnClose.addEventListener('click',closeModal);
btnMute.addEventListener('click',function(e){
  e.stopPropagation();
  muted=!muted;mv.muted=muted;icon();
  if(!muted){var p=mv.play();if(p&&p.catch)p.catch(function(){});}
});
bar.addEventListener('click',openSheet);
bar.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openSheet();}});
sclose.forEach(function(b){b.addEventListener('click',closeSheet);});
modal.addEventListener('click',function(e){if(e.target===modal)closeModal();});
function onKey(e){
  if(!isOpen)return;
  if(e.key==='Escape'){if(modal.classList.contains('sheet'))closeSheet();else closeModal();}
  else if(e.key==='ArrowLeft')show(cur-1);
  else if(e.key==='ArrowRight')show(cur+1);
}
document.addEventListener('keydown',onKey);

/* swipe on the video: left/right or up/down = next/prev reel. Tap = pause/play */
var sX=0,sY=0,drag=false,moved=0;
function skip(t){return t.closest&&t.closest('button,a,[data-bar]');}
vs.addEventListener('touchstart',function(e){if(skip(e.target))return;sX=e.touches[0].clientX;sY=e.touches[0].clientY;drag=true;},{passive:true});
vs.addEventListener('touchend',function(e){
  if(!drag)return;drag=false;
  if(modal.classList.contains('sheet'))return;
  var dx=sX-e.changedTouches[0].clientX,dy=sY-e.changedTouches[0].clientY,ax=Math.abs(dx),ay=Math.abs(dy);
  if(ax>50&&ax>ay){moved=1;show(dx>0?cur+1:cur-1);}
  else if(ay>60&&ay>ax){moved=1;show(dy>0?cur+1:cur-1);}
},{passive:true});
var mx=0,md=false;
vs.addEventListener('mousedown',function(e){if(skip(e.target))return;mx=e.clientX;md=true;moved=0;});
vs.addEventListener('mouseup',function(e){
  if(!md)return;md=false;
  var dx=mx-e.clientX;
  if(Math.abs(dx)>60){moved=1;show(dx>0?cur+1:cur-1);}
});
vs.addEventListener('mouseleave',function(){md=false;});
vs.addEventListener('click',function(e){
  if(skip(e.target))return;
  if(moved){moved=0;return;}
  if(mv.paused){var p=mv.play();if(p&&p.catch)p.catch(function(){});}else{mv.pause();}
});

/* each slider */
function initSlider(sec,data){
  var slider=sec.querySelector('[data-slider]');
  var cards=[].slice.call(sec.querySelectorAll('.ccr__card'));
  var pv=sec.querySelector('[data-prev]'),nx=sec.querySelector('[data-next]');
  cards.forEach(function(c,i){
    var cv=c.querySelector('video');
    function warm(){if(!cv.getAttribute('src'))cv.src=cv.getAttribute('data-src');cv.preload='auto';}
    c.addEventListener('mouseenter',warm);
    c.addEventListener('touchstart',warm,{passive:true});
    c.addEventListener('focus',warm);
    c.addEventListener('click',function(){openModal(data,i,cv);});
    c.addEventListener('keydown',function(e){if(e.target!==c)return;if(e.key==='Enter'||e.key===' '){e.preventDefault();openModal(data,i,cv);}});
  });

  function upd(){
    pv.classList.toggle('is-off',slider.scrollLeft<=2);
    nx.classList.toggle('is-off',slider.scrollLeft>=slider.scrollWidth-slider.clientWidth-2);
  }
  pv.addEventListener('click',function(){slider.scrollBy({left:-slider.clientWidth*0.8,behavior:'smooth'});});
  nx.addEventListener('click',function(){slider.scrollBy({left:slider.clientWidth*0.8,behavior:'smooth'});});
  slider.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',upd);
  offs.push(function(){window.removeEventListener('resize',upd);});
  upd();

  var vids=cards.map(function(c){return c.querySelector('video');});
  if(!('IntersectionObserver' in window)){
    vids.forEach(function(v){v.src=v.getAttribute('data-src');var p=v.play();if(p&&p.catch)p.catch(function(){});});
    return;
  }
  /* load a video only when its card is near the viewport (saves bandwidth) */
  var loader=new IntersectionObserver(function(es){
    es.forEach(function(en){
      if(en.isIntersecting){
        var v=en.target.querySelector('video');
        if(!v.getAttribute('src')){v.src=v.getAttribute('data-src');v.preload='metadata';}
        loader.unobserve(en.target);
      }
    });
  },{root:slider,rootMargin:'0px 300px 0px 300px'});
  /* play only visible cards, pause the rest */
  var player=new IntersectionObserver(function(es){
    es.forEach(function(en){
      var v=en.target.querySelector('video');
      if(en.isIntersecting){
        if(!v.getAttribute('src'))v.src=v.getAttribute('data-src');
        var p=v.play();if(p&&p.catch)p.catch(function(){});
      }else{v.pause();}
    });
  },{threshold:0.4});
  cards.forEach(function(c){loader.observe(c);player.observe(c);});
  offs.push(function(){loader.disconnect();player.disconnect();});
}

var raw=[];
try{raw=JSON.parse(sec.getAttribute('data-reels')||'[]');}catch(e){}
var badge=sec.getAttribute('data-badge')!=='0';
var data=raw.map(function(r){return prep(r,badge);});
initSlider(sec,data);
return{
  destroy:function(){
    document.removeEventListener('keydown',onKey);
    offs.forEach(function(f){try{f();}catch(e){}});
    document.documentElement.style.overflow=prevOverflow;
    clearTimeout(closeTimer);clearTimeout(toastTimer);
    pool.forEach(function(el){el.pause();el.removeAttribute('src');});
    if(modal.parentNode)modal.parentNode.removeChild(modal);
  }
};
}

/* ---------- lifecycle (works with the theme editor too) ---------- */
function start(sec){
  var id=sec.getAttribute('data-modal');
  if(!id||INST[id])return;
  var inst=mount(sec);
  if(inst)INST[id]=inst;
}
function stop(sec){
  var id=sec.getAttribute('data-modal');
  if(id&&INST[id]){INST[id].destroy();delete INST[id];}
}
function boot(root){[].forEach.call((root||document).querySelectorAll('[data-ccr]'),start);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot();});else boot();
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
document.addEventListener('shopify:section:unload',function(e){[].forEach.call(e.target.querySelectorAll('[data-ccr]'),stop);});
})();